/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module ApplicationinfoTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface ApplicationInfo {
    [k: string]: any;
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "ApplicationLifetimeEvent".
 */
export interface ApplicationLifetimeEvent {
    type: ApplicationLifetimeEventType;
    reason?: ShutdownReason;
}
/**
 * Open System Setting Parameters
 *
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "OpenSystemSettingParameters".
 */
export interface OpenSystemSettingParameters {
    systemSetting: SystemSetting;
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "IsApplicationRunningParameters".
 */
export interface IsApplicationRunningParameters {
    name?: string;
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "OpenFileDialogParameters".
 */
export interface OpenFileDialogParameters {
    /**
     * If true allow the user to select a file.  If false, select a directory.
     */
    includeFiles?: boolean;
    /**
     * Name/Value pairs of file types and their corresponding file extension.
     */
    filter?: {
        [k: string]: any;
    };
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "SaveFileAsDialogParameters".
 */
export interface SaveFileAsDialogParameters {
    /**
     * Default file name shown in the Save File As dialog.
     */
    defaultFileName?: string;
    /**
     * Name/Value pairs of file types and their corresponding file extension.
     */
    filter?: {
        [k: string]: any;
    };
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "OpenDirectoryBrowserParameters".
 */
export interface OpenDirectoryBrowserParameters {
    /**
     * Fully qualified path to the directory in which to open directory browser
     */
    name: string;
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "GetApplicationTimeInfoParameters".
 */
export interface GetApplicationTimeInfoParameters {
    type: ApplicationTimeType;
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "GetApplicationTimeInfoReturn".
 */
export interface GetApplicationTimeInfoReturn {
    /**
     * Time(ms) taken for launching the process indicated in the type field.
     */
    startTime?: number;
    type?: ApplicationStartTimeType;
    /**
     * Time(ms from epoch) taken for site load to start, accounting for startTime and nodeInitTime.
     */
    siteLoadStartTime?: number;
    /**
     * Time(ms from epoch) taken for cef init.
     */
    cefInitTime?: number;
    /**
     * Is it a second UI launch in the same boot session.
     */
    isWarmLaunch?: boolean;
}

/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "ApplicationLifetimeEventType".
 */
export enum ApplicationLifetimeEventType {
    ApplicationExit = 'APPLICATION_EXIT',
    SystemLogout = 'SYSTEM_LOGOUT',
    SystemSuspend = 'SYSTEM_SUSPEND'
}
/**
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "ShutdownReason".
 */
export enum ShutdownReason {
    UserClosedWindow = 'USER_CLOSED_WINDOW',
    UserQuitWithShortcut = 'USER_QUIT_WITH_SHORTCUT',
    UserLoggedOut = 'USER_LOGGED_OUT',
    SelfUpdate = 'SELF_UPDATE',
    Relaunch = 'RELAUNCH',
    BrowserExit = 'BROWSER_EXIT',
    ForceShutdown = 'FORCE_SHUTDOWN'
}
/**
 * The name of a system setting
 *
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "SystemSetting".
 */
export enum SystemSetting {
    Bluetooth = 'BLUETOOTH'
}
/**
 * Type of Application Time requested in parameters. More can be added as required.
 *
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "ApplicationTimeType".
 */
export enum ApplicationTimeType {
    Launch = 'launch'
}
/**
 * Type corresponding to Application Start Time in response
 *
 * This interface was referenced by `ApplicationInfo`'s JSON-Schema
 * via the `definition` "ApplicationStartTimeType".
 */
export enum ApplicationStartTimeType {
    LaunchSiteTime = 'LAUNCH_SITE_TIME',
    LaunchCefSiteTime = 'LAUNCH_CEF_SITE_TIME'
}


}
